import type { ApplicationGateApi } from '@tempmee/awards';
import * as Client from '../clients/GetApplicationQuestions';

export const getApplicationQuestionsService = async (
  cycleId: string,
): Promise<ApplicationGateApi> => {
  return Client.getApplicationQuestions(cycleId);
};
